import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { setIsClosed } from "../store/slices/navigationSlice";

const pathToPage = (path: string): string => {
  const page = path.replace(/^\//, "") || "home";
  return page as string;
};

export const useNavigateApp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const activePage = pathToPage(location.pathname);
  const isClosed = useAppSelector((state) => state.navigation.isClosed);

  const navigateTo = (page: string) => {
    const path = page === "home" ? "/" : `/${page}`;
    navigate(path);
    dispatch(setIsClosed(false));
  };

  const updateNavigation = (page: string) => {
    navigateTo(page);
  };

  const isActivePage = (page: string): boolean => activePage === page;

  const setMenuClosed = (closed: boolean) => {
    dispatch(setIsClosed(closed));
  };

  return {
    activePage,
    isClosed,
    navigateTo,
    updateNavigation,
    isActivePage,
    setMenuClosed,
  };
};
